module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAALtJREFUOE+10j0OgkAQBeD3tvMWoLa2loq9sVM8iqClCkcBLT2AP516BRUOYnaMjTEG2JCN227my8y8ISwfLevxH0DiZgdPaXCRXUwdFnYgS7cLxR2ofQb5oQopHUHWTh9QG1D5DG6lSOUOJHZ70NxCOOX8vi/qxLjEDwI9YpiffxEzsGoNQElADBk8rrUAidoeoFNQxpxlp1ojSOR4EJVClRe/weoYoScM82PtGK0PyXR93//GFEyYNfACwnI/EUhq56QAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/switchover_icon_arrow.png
// module id = ouq0
// module chunks = 0